import React, { useMemo, useState } from 'react';
import { Button, Input } from '@heroui/react';

export default function AhrefsAccountConfigurator({
  account,
  saving,
  onSubmit,
  onCancel,
}) {
  const initialConfig = useMemo(
    () => account?.metadata?.ahrefs ?? {},
    [account?.metadata?.ahrefs],
  );
  const isCreate = !account?.id;

  const [accessToken, setAccessToken] = useState('');
  const [firehoseUrl, setFirehoseUrl] = useState(initialConfig.firehoseUrl ?? '');
  const [tapId, setTapId] = useState(initialConfig.tapId ?? '');

  const handleSubmit = () => {
    const trimmedToken = accessToken.trim();
    if (isCreate && !trimmedToken) {
      console.warn('Enter a tap token');
      return;
    }
    onSubmit?.({
      accessToken: trimmedToken || undefined,
      metadata: {
        ahrefs: {
          firehoseUrl: firehoseUrl.trim() || undefined,
          tapId: tapId.trim() || undefined,
        },
      },
    });
  };

  return (
    <div className="space-y-4">
      <p className="text-sm text-default-500">
        Connect Ahrefs Firehose with a tap token. The token is stored on the integration account and used for the SSE stream.
      </p>

      <Input
        label="Tap token"
        labelPlacement="outside"
        placeholder="fh_..."
        description={isCreate ? 'Required. Paste the Firehose tap token.' : 'Optional. Leave blank to keep the current token.'}
        type="password"
        value={accessToken}
        onValueChange={setAccessToken}
      />

      <Input
        label="Default stream URL"
        labelPlacement="outside"
        placeholder="https://api.firehose.com/v1/stream"
        description="Optional. Used as the default stream URL for Ahrefs external steps."
        value={firehoseUrl}
        onValueChange={setFirehoseUrl}
      />

      <Input
        label="Default tap ID"
        labelPlacement="outside"
        placeholder="tap_..."
        description="Optional. Used when a step does not override the tap id."
        value={tapId}
        onValueChange={setTapId}
      />

      <div className="flex justify-end gap-2">
        <Button variant="light" onPress={onCancel} isDisabled={saving}>
          Cancel
        </Button>
        <Button color="primary" onPress={handleSubmit} isLoading={saving}>
          {isCreate ? 'Save connection' : 'Save changes'}
        </Button>
      </div>
    </div>
  );
}
